import React, { Component } from 'react';
import Helmet from 'react-helmet';

const faviconLinks = [
    {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: '/76-en.png'
    },
    {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: '/120-en.png'
    },
    {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: '/152-en.png'
    },
    {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: '/180-en.png'
    },
    {
        rel: 'shortcut icon',
        sizes: '16x16',
        href: '/16-en.png'
    },
    {
        rel: 'shortcut icon',
        sizes: '32x32',
        href: '/32-en.png'
    },
    {
        rel: 'shortcut icon',
        href: '/favicon-en.png'
    }
];

export default class Favicon extends Component {
    public render() {
        const linkElements = faviconLinks
            .map((link, i) => (
                <link key={`link-${i}`} {...link} />
            ));

        return <Helmet>{linkElements}</Helmet>;
    }
}
